import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import { LanguageContext } from 'containers/LanguageProvider';

import { NewButton as Button, type ButtonProps } from 'components/Button/NewButton';

import { ToggleableContext } from 'utilsTS/hooks';

export interface ModalHeaderCloseProps extends Omit<ButtonProps, 'children'> {
    small?: boolean;
    closeLabel?: string;
    closeProps?: Partial<ButtonProps>;
    onCloseButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const ModalHeaderClose: React.FC<ModalHeaderCloseProps> = ({
    small,
    closeLabel,
    onCloseButtonClick = noop,
    ...rest
}) => {
    const { getString } = useContext(LanguageContext);
    const { close } = useContext(ToggleableContext);

    const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        onCloseButtonClick(event);
        close();
    };

    return (
        <Button
            {...rest}
            hiddenLabel={small ? Button.HIDDEN_LABEL.ALWAYS : Button.HIDDEN_LABEL.BELOW_MD}
            variant={Button.VARIANT.TERTIARY}
            size={Button.SIZE.SMALL}
            icon={Button.ICON.ERROR}
            iconClassName="g-button-icon-right"
            fullWidth={Button.FULL_WIDTH.NEVER}
            className="modal-close"
            onClick={handleClick}
        >
            {getString('common.close', closeLabel)}
        </Button>
    );
};

ModalHeaderClose.displayName = 'ModalHeaderClose';
ModalHeaderClose.propTypes = {
    small: PropTypes.bool,
    closeLabel: PropTypes.string,
    onCloseButtonClick: PropTypes.func,
};
